import { ContentType } from "@/api/scode/scode_params";
import { onShareAppMessageByRanking } from "@/utils/actions";
import { useEffect } from "react";

/**
 * 榜单分享Hook
 * 用于处理榜单页面的分享逻辑，包括榜单分享和商品分享
 */
export interface RankShareConfig {
  // 榜单分享配置
  rankShare: {
    contentType: ContentType; // 内容类型：榜单中心或类目榜单
    oneCategoryId?: string;
    contentId: string; // 内容ID：榜单ID或类目ID
    title?: string; // 分享标题
    shareType: string;
    posterCode: string;
    pageName: string;// 市场名称：榜单中心或榜单详情
  };
}

/**
 * @returns 分享相关的控制器和方法
 */
export const useRankSystemShare = (config: RankShareConfig) => {
  const { rankShare } = config;
  // 监听依赖更新，同步右上角分享入口的分享配置
  useEffect(() => {
    const { contentType, oneCategoryId, contentId, title, shareType, posterCode,pageName  } =
      rankShare || {};
    // 确保contentId有值再更新配置
    if (!contentId) {
      // console.warn("榜单分享配置更新失败：contentId为空", rankShare);
      return;
    }

    //  查询并配置榜单页右上角的分享卡片信息（点击右上角三个点，分享给好友、朋友圈等）
    onShareAppMessageByRanking({
      contentType,
      oneCategoryId,
      contentId,
      title,
      shareType,
      posterCode,
      pageName,
    });
  }, [rankShare.contentType, rankShare.contentId]);
};
